// @flow
import BaseComponent from '../../base_component/base_component'
import componentLocator from '../../../assets/javascripts/component_locator'

export default class SearchBar extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        this.enableFilters();
    }

    enableFilters() {
        let filtersActive = false;
        let $filterIcon = $(this.component).find('.filter-icon')
        componentLocator.getAll('filter_panel').then((filters: any[]) => {
            $filterIcon.click(() => {
                filtersActive = !filtersActive;
                filters.forEach((filter: any) => filter.toggle(filtersActive));
                $filterIcon.toggleClass('active', filtersActive);
            })
            filters.forEach(f => f.callbacks.push(isActive => {
                filtersActive = isActive;
                $filterIcon.toggleClass('active', isActive);
            }))
        });
    }
}